module.exports = __webpack_public_path__ + "img/1538600161.030a35df.jpg";